function CardWrap({ children }) {
  return (
    <div className="bg-dark-bg p-[20px] space-y-2 rounded-md">{children}</div>
  );
}

export default CardWrap;
